import styled from "styled-components";

export const DevicesStyle = styled.div`
    ${({theme}) => `
        @media (min-width: 1920px) {
            padding-right: 152px;
            width: 1440px;
            margin: 0 auto;
        }
    `}
`
